import { useSearchParams } from "react-router-dom";
import SEO from "@/components/SEO";
import EnquiryForm from "@/components/EnquiryForm";
import { Reveal, Kicker } from "@/components/Reveal";
import { useSettings } from "@/context/SettingsContext";
import { telLink, waLink } from "@/lib/api";
import { Phone, MessageCircle } from "lucide-react";

export default function Quote() {
  const s = useSettings();
  const [params] = useSearchParams();
  const product = params.get("product") || "";
  const model = params.get("model") || "";

  return (
    <>
      <SEO
        title="Request a Quote | Hari Om Trading Co. — Tahliwal, Una"
        description="Send your product name, model number and quantity to Hari Om Trading Co., Tahliwal for availability and quotation information."
      />
      <section className="grain bg-[#111111] bg-grid-dark py-16 lg:py-24" data-testid="quote-hero">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <Reveal>
            <Kicker dark>Quotation</Kicker>
            <h1 className="mt-4 font-heading text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
              Request a Quote
            </h1>
            <p className="mt-4 max-w-2xl text-base text-[#b8bec8]">
              Share the product name, model number and quantity. Your enquiry goes directly to
              Hari Om Trading Co.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[#F6F7F8] py-16 lg:py-24">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-[1.2fr_0.8fr]">
          <Reveal>
            <div className="border border-[#D9DDE3] bg-white p-6 sm:p-10">
              <EnquiryForm defaultProduct={product} defaultModel={model} source="quote" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="space-y-5">
              <div className="bg-[#111111] p-8" data-testid="quote-alt-contact">
                <h2 className="font-heading text-xl font-semibold text-white">Prefer to talk directly?</h2>
                <p className="mt-2 text-sm text-[#b8bec8]">Call or message with your requirement.</p>
                <div className="mt-6 space-y-3">
                  <a href={telLink(s)} data-testid="quote-call" className="flex min-h-[48px] items-center justify-center gap-2 bg-[#F5B700] px-5 py-3 font-heading text-[15px] font-semibold text-[#111111] hover:bg-[#D99C00]">
                    <Phone size={16} aria-hidden="true" /> {s.phone}
                  </a>
                  <a href={waLink(s)} target="_blank" rel="noopener noreferrer" data-testid="quote-whatsapp" className="flex min-h-[48px] items-center justify-center gap-2 border border-[#3a3d42] px-5 py-3 font-heading text-[15px] font-semibold text-white hover:border-[#18864B] hover:text-[#4ade80]">
                    <MessageCircle size={16} aria-hidden="true" /> WhatsApp Us
                  </a>
                </div>
              </div>
              <div className="border border-[#D9DDE3] bg-white p-8" data-testid="quote-hours">
                <h3 className="font-heading text-base font-semibold text-[#161616]">Opening Hours</h3>
                <p className="mt-2 text-sm text-[#667085]">{s.hours_weekday}</p>
                <p className="text-sm text-[#667085]">{s.hours_sunday}</p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
